import React from 'react';
import { motion } from 'framer-motion';
import { FileTextIcon, SearchIcon, DollarSignIcon } from 'lucide-react';
const steps = [{
  number: 1,
  title: 'Apply in Minutes',
  description: 'Fill out our simple pre-qualification form.'
}, {
  number: 2,
  title: 'Get Matched',
  description: 'We match you with the best funding options.'
}, {
  number: 3,
  title: 'Receive Funding',
  description: 'Get approved and receive funds in 24–48 hours.'
}];
export function HowItWorks() {
  const scrollToForm = () => {
    document.getElementById('qualify-form')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-12 px-4 bg-black" data-id="element-67">
      <div className="max-w-7xl mx-auto" data-id="element-68">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="font-serif text-4xl md:text-5xl text-center mb-10" data-id="element-69">
          How It Works
        </motion.h2>

        <div className="grid md:grid-cols-3 gap-12 relative mb-12" data-id="element-70">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-8 left-0 right-0 h-0.5 bg-gradient-to-r from-transparent via-gold-primary/30 to-transparent" data-id="element-71" />

          {steps.map((step, index) => {
          return <motion.div key={step.number} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: index * 0.2
          }} className="relative text-center" data-id="element-72">
                <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-gold-primary text-black font-bold text-2xl mb-6 relative z-10" data-id="element-73">
                  {step.number}
                </div>
                <h3 className="text-2xl font-bold mb-3" data-id="element-74">{step.title}</h3>
                <p className="text-gray-400 leading-relaxed" data-id="element-75">
                  {step.description}
                </p>
              </motion.div>;
        })}
        </div>

        <motion.div className="text-center" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.6
      }} data-id="element-76">
          <button onClick={scrollToForm} className="bg-gold-primary text-black font-bold text-lg md:text-xl px-10 py-4 rounded-lg hover:bg-gold-accent transition-all duration-300 hover:shadow-[0_0_30px_rgba(240,185,11,0.4)]" data-id="element-77">
            Start Your Application →
          </button>
        </motion.div>
      </div>
    </section>;
}